export default "__VITE_ASSET__DScXZnxq__"